export default __webpack_public_path__ + "fonts/MarrSansCondensed-Regular-Web.woff2";